jQuery(function ($) {

    const vetSingleProduct = {
        init: () => {

        }
    }

    //Single product quantity input change
    if ( !String.prototype.getDecimals ) {
        String.prototype.getDecimals = function () {
            var num = this,
                match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
            if ( !match ) {
                return 0;
            }
            return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
        };
    }
    // Quantity "plus" and "minus" buttons
    $(document.body).on('click', '.plus, .minus', function () {
        var $qty = $(this).closest('.quantity').find('.qty'),
            currentVal = parseFloat($qty.val()),
            max = parseFloat($qty.attr('max')),
            min = parseFloat($qty.attr('min')),
            step = $qty.attr('step');

        // Format values
        if ( !currentVal || currentVal === '' || currentVal === 'NaN' ) currentVal = 0;
        if ( max === '' || max === 'NaN' ) max = '';
        if ( min === '' || min === 'NaN' ) min = 0;
        if ( step === 'any' || step === '' || step === undefined || parseFloat(step) === 'NaN' ) step = 1;

        // Change the value
        if ( $(this).is('.plus') ) {
            if ( max && (currentVal >= max) ) {
                $qty.val(max);
            } else {
                $qty.val((currentVal + parseFloat(step)).toFixed(step.getDecimals()));
            }
        } else {
            if ( min && (currentVal <= min) ) {
                $qty.val(min);
            } else if ( currentVal > 0 ) {
                $qty.val((currentVal - parseFloat(step)).toFixed(step.getDecimals()));
            }
        }

        // Trigger change event
        $qty.trigger('change');
    });

    //Single product gallery
    $('.product-gallery-slider').slick({
        arrows: false,
        fade: true,
        asNavFor: '.product-gallery-slider-nav',
    });
    let navSlider = $('.product-gallery-slider-nav');
    navSlider.slick({
        slidesToShow: 4,
        asNavFor: '.product-gallery-slider',
        focusOnSelect: true,
        arrows: true,
        infinite: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    if ( navSlider.find('.slick-slide').length <= 3 ) {
        navSlider.addClass('disable-scrolling');
    }


    /**
     * @dsc Single product tabs on mobile
     */

    setTimeout(function(){
        $('.wc-tabs--mobile .wc-tabs__tab-wrapper').each(function(index){
            $(this).find('.woocommerce-Tabs-panel').show();

            if (index == 0) {
                const titleBlock = $(this).find('.wc-tabs__tab-title');
                vetToggleSingleProductTab(titleBlock);
            }
        });
    }, 1000);


    $('.wc-tabs--mobile .wc-tabs__tab-wrapper .wc-tabs__tab-title').on('click', function() {
        const titleBlock = $(this);

        vetToggleSingleProductTab(titleBlock);
    });


    /**
     * @dsc
     * @param titleBlock
     */
    function vetToggleSingleProductTab(titleBlock) {
        const activeClass = 'active';
        const tabPanel = titleBlock.parent().find('.wc-tabs__tab-content-wrapper');
        const panelToggleHeight = titleBlock.hasClass(activeClass) ? 0 : tabPanel.get(0).scrollHeight;

        titleBlock.toggleClass(activeClass);
        tabPanel.toggleClass(activeClass);

        tabPanel.animate({ height: panelToggleHeight }, 200, function(){
            const height = panelToggleHeight > 0 ? 'auto' : panelToggleHeight;

            $(this).height(height);
        } );
    }


    // Badge change font size to fit in div
    $('.badge  > div').each( function(index) {
        $(this).css('font-size', '15px');

        while ( $(this).height() > $(this).parent().height() ) {
            $(this).css('font-size', ( parseInt( $(this).css('font-size') ) - 1) + 'px');
        }

        $(this).parent().addClass('loaded');
    });

    setTimeout(function(){
        $('.woocommerce-tabs').addClass('loaded');
        $('.wc-tabs--mobile').addClass('loaded');
        $('.single-product__info').find('.info-column').removeClass('vet-not-visible');

        setVariableProductVariationData();
    }, 1100);

    $(document).on('found_variation', function (e, v) {
        setVariableProductVariationData();
    });

    function setVariableProductVariationData() {
        const variationDataContainer = $('.single-product__row > .summary.entry-summary > form > .single_variation_container > .single_variation_wrap:not(.qdiscount-wrapper) > .woocommerce-variation.single_variation');
        const variationSku = variationDataContainer.find('.woocommerce-variation-sku').text();
        const variationVetSku = variationDataContainer.find('.vet_sku').text();

        const sku = variationVetSku ? variationVetSku : variationSku;

        $('.single-product__info').find('.sku-val').html( sku );
    }
});